import { useMapEvent } from "react-leaflet";

export default function PopupCloseHandler({ onClose }) {
	useMapEvent("popupclose", onClose);
	return null;
}
